import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { CustomCloseAccountComponentService } from '@my-account/feature';
import { ModalComponent, SdvorButtonComponent } from '@sdvor/shared/ui';
import { ModalRef, ModalService } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'sd-custom-close-account-modal',
  templateUrl: './custom-close-account-modal.component.html',
  styleUrls: ['./custom-close-account-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CustomCloseAccountComponentService],
  imports: [ModalComponent, SdvorButtonComponent],
})
export class CustomCloseAccountModalComponent implements OnInit, OnDestroy {
  modal: ModalRef;
  private subscription = new Subscription();

  constructor(
    protected service: CustomCloseAccountComponentService,
    protected modalService: ModalService,
    protected router: Router,
  ) {}

  ngOnInit(): void {
    this.modal = this.modalService.getActiveModal();

    // при смене урла текущая модалка закрывается
    this.subscription.add(
      this.router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe(() => {
        this.modal.close();
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onDelete(): void {
    this.service.closeAccount();
  }
}
